import * as React from 'react'

import { observer } from 'mobx-react'

import Localization from '~/client/src/shared/localization/LocalizationManager'

import { IBaseStepDiagramProps } from './BaseStepDiagram'
import RequestStepDiagram from './RequestStepDiagram'

// localization: translated

@observer
export default class SubmissionStepDiagram extends React.Component<IBaseStepDiagramProps> {
  public render() {
    return (
      <RequestStepDiagram
        {...this.props}
        intermediateStateText={Localization.translator.submitted}
      />
    )
  }
}
